import type { OrganizationBranding } from "@/client"
import { determineOrgId } from "@/hooks/useBranding"
import type { PercentileColorScheme } from "@/types/percentileColors"
import {
  DEFAULT_PERCENTILE_COLOR_SCHEME,
  getPercentileColor,
  resolveTextColor,
} from "@/utils/percentileColors"
import { useQueryClient } from "@tanstack/react-query"

export function useOrgColorScheme() {
  const queryClient = useQueryClient()
  const orgId = determineOrgId(queryClient)

  // Read from the already-cached branding query — no extra network call
  const branding = queryClient.getQueryData<OrganizationBranding>([
    "branding",
    orgId,
  ])
  const rawScheme = branding?.percentile_color_scheme
  const scheme: PercentileColorScheme =
    Array.isArray(rawScheme) && rawScheme.length > 0
      ? (rawScheme as PercentileColorScheme)
      : DEFAULT_PERCENTILE_COLOR_SCHEME

  return {
    getColor: (percentile: number) => getPercentileColor(percentile, scheme),
    getTextColor: (percentile: number) =>
      resolveTextColor(getPercentileColor(percentile, scheme)),
  }
}
